<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ 'product_assigned_menu' | translate }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="d-flex mx-0 mt-2 justify-content-between">
        <nb-select class="col-auto pr-0 ml-auto" style="width:180px" [(ngModel)]="selectPRDMenuNo" (selectedChange)="onQuery()">
          <nb-option *ngFor="let item of titleList" [value]="item.value">
            {{ item.label }}
          </nb-option>
        </nb-select>
      </div>

      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ 'product_menu_category' | translate }}</th>
              <th>{{ 'product_menu' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of mainDataList">
              <tr>
                <td>{{ e.GroupName }}</td>
                <td style="vertical-align: middle;">{{e.Title}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #PdModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      {{ 'common_select' | translate }}{{ 'common_product_name' | translate }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ 'common_product_name' | translate }}</th>
              <th>{{ 'common_enable' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of showListPd">
              <tr>
                <td>{{ e.ProductName }}</td>
                <td>
                  <nb-toggle status="info" class="" [(checked)]="e.IsOK_Product" [disabled]="e.IsCanSelect == 0"></nb-toggle>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSavePd();">{{ 'common_confirm' | translate }}</button>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
